import PropTypes from 'prop-types';

export const OPEN_LABEL = 'Open';
export const CLOSED_LABEL = 'Closed';
export const OPENS_AT_LABEL = 'Opens at';
export const CLOSES_AT_LABEL = 'Closes at';
export const ADD_HOLIDAY_HOURS_LABEL = 'Add holiday hours';

export const TIME_SELECT_FIELDS = [
  { label: OPENS_AT_LABEL, valueKey: 'opensAt' },
  { label: CLOSES_AT_LABEL, valueKey: 'closesAt' },
];

export const DAYS_OF_THE_WEEK = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const dayHoursPropType = PropTypes.shape({
  closesAt: PropTypes.string,
  day: PropTypes.number,
  isActive: PropTypes.bool,
  maxVisitors: PropTypes.number,
  opensAt: PropTypes.string,
});
